import React, { Component } from 'react'

export class Resources extends Component { 

  render() {
    return (
      <div>
        <div className="container p-md-0">
          <div className="az-content-body">
            <div className="az-dashboard-one-title">
              <div>
                <h2 className="az-dashboard-title">Resources</h2>
                <p className="mt-2 font-weight-normal">Collection of Security Blogs.</p>
              </div>
            
            </div>{/* az-dashboard-one-title */}


            <div className="az-notification-list">
                            
                 
                    <div className="media new mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Talos Intelligence</h6>
                        <p className="card-text mt-2 mb-2">
                        Talos utilizes its extensive threat intelligence to make the internet safer for everyone. A variety of free software, services, resources and data are available to the public, including official rule sets and communities.
                        </p>
                        <a href="https://blog.talosintelligence.com" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Abuse.ch URLhaus</h6>
                        <p className="card-text mt-2 mb-2">
                        URLhaus is a project operated by abuse.ch with the purpose of sharing malicious URLs that are being used for malware distribution.
                        </p>
                        <a href="https://urlhaus.abuse.ch" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>


                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">National Cyber Awareness System Reports</h6>
                        <p className="card-text mt-2 mb-2">
                        Analysis Reports provide in-depth analysis on a new or evolving cyber threat.
                        </p>
                        <a href="https://us-cert.cisa.gov/ncas/alerts" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      </div>
                    </div>

                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Checkpoint Research</h6>
                        <p className="card-text mt-2 mb-2">
                        Check Point Research provides leading cyber threat intelligence to Check Point Software customers and the greater intelligence community. 
                        </p>
                        <a href="https://research.checkpoint.com" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      </div>
                    </div>

                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      
                      <div className="media-body">
                  
                        <h6 className="card-title-card">Crowdstrike Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        The Crowdstrike Cybersecurity blog is home to exclusive endpoint, cloud, and threat intelligence trends, articles, and research. Learn and read more here. 
                        </p>
                        <a href="https://www.crowdstrike.com/blog/category/threat-intel-research/" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">FireEye Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        The FireEye blog provides information and insight on advanced cyber attacks, threat research and cyber security issues facing organizations today.
                        </p>
                        <a href="https://www.fireeye.com/blog.html" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">PhishStats</h6>
                        <p className="card-text mt-2 mb-2">
                        Fighting phishing and cybercrime since 2014 by gathering, enhancing and sharing phishing information with the infosec community.
                        </p>
                        <a href="https://phishstats.info/" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Yoroi Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        Threat intelligence is our core knowledge constantly processed by our artificial intelligence engines to help cybersecurity analysts.
                        </p>
                        <a href="https://yoroi.company/blog/" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>

                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Free and Open Source Threat Intelligence Feeds</h6>
                        <p className="card-text mt-2 mb-2">
                        Indicator of Compromise, IoC, URL, Domain, IP, File Hash, STIX and YARA free and open source feeds list. Free to use in your SOC, SOAR, CDC and SIEM.
                        </p>
                        <a href="https://www.threat-intel.xyz" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Microsoft Security Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        Expert coverage on security matters such as zero trust, identity and access management, threat protection, information protection, and security.
                        </p>
                        <a href="https://www.microsoft.com/security/blog/" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Fortinet Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        Explore the latest cybersecurity trends and innovations, leading edge threat intelligence from FortiGuard Labs.
                        </p>
                        <a href="https://www.fortinet.com/blog" rel="noopener noreferrer" target="_blank" className=""><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Intezer Blog</h6>
                        <p className="card-text mt-2 mb-2">
                        You'll find posts on the latest cybersecurity news from our team of experts, along with industry insights.
                        </p>
                        <a href="https://www.intezer.com/blog/" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>
                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Security Soup</h6>
                        <p className="card-text mt-2 mb-2">
                        Hello and welcome to Sec Soup, where the weekly newsletter has a collection of infosec links to Tools & Tips, Threat Research, and more!.
                        </p>
                        <a href="https://security-soup.net" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>

                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link online">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">Proofpoint Emerging Threats Rules</h6>
                        <p className="card-text mt-2 mb-2">
                        Emerging Threat (ET) Intelligence provides actionable threat intel feeds to identify IPs and domains involved in suspicious and malicious activity.
                        </p>
                        <a href="https://rules.emergingthreats.net" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      
                      </div>
                    </div>

                    <div className="media new mt-2 mb-2">
                      <div className="az-img-link">
                        <img
                          src={require("../../assets/images/link.png")}
                          alt=""
                        ></img>
                      </div>
                      <div className="media-body">
                        <h6 className="card-title-card">awesome-threat-intelligence</h6>
                        <p className="card-text mt-2 mb-2">
                        A curated list of awesome Threat Intelligence resources. A concise definition of Threat Intelligence: evidence-based knowledge, including context, mechanisms, indicators, implications and actionable advice, about an existing or emerging menace or hazard to assets that can be used to inform decisions regarding the subject’s response to that menace or hazard.
                        </p>
                        <a href="https://github.com/hslatman/awesome-threat-intelligence" rel="noopener noreferrer" target="_blank" className="mt-2"><i className="icon icon ion-md-exit mr-2"></i>VIEW SITE</a> 
                      </div>
                    </div>



                  </div>




              
       
        
          </div>{/* az-content-body */}
          <hr className="mg-y-30"/>
        </div>
      </div>
    )
  }
}

export default Resources